
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
export default class AppHeader1 extends Vue {
  @State("school", { namespace: "school" })
  private school!: any;
  @State("template", { namespace: "school" })
  private template!: any;

  @Prop({ default: false })
  private isUniversity!: boolean;
  @Prop({ default: null })
  private showAppLogin!: any;
  @Prop({ default: "Unknown" })
  private getAppLoginTitle!: string;
  @Prop({ default: "" })
  private email!: string;
  @Prop({ default: "" })
  private password!: string;
  @Prop({ default: false })
  private isForgotPassword!: boolean;
  @Prop({ default: null })
  private handleClickButton!: any;
  @Prop({ default: null })
  private closeAppLogin!: any;
  @Prop({ default: null })
  private submit!: any;
  @Prop({ default: null })
  private togglePassword!: any;

  private onEmail(event) {
    this.$emit("update:email", event.target.value);
  }

  private onPassword(event) {
    this.$emit("update:password", event.target.value);
  }
}
